/**
 * Option lists for the nowcasts `<SegmentedControl>` selectors (Timeframe,
 * Inflation Type, GDP View). Extracted from the three former *Selector
 * components so call sites can pass them straight into `<SegmentedControl>`.
 */
import type { GdpViewSelector, InflationType, Timeframe } from '../types';

/** Timeframe button row — full set; the active country's config narrows it. */
export const TIMEFRAME_OPTIONS: ReadonlyArray<{ value: Timeframe; label: string }> = [
  { value: '1y', label: '1Y' },
  { value: '2y', label: '2Y' },
  { value: '5y', label: '5Y' },
  { value: '10y', label: '10Y' },
  { value: '30y', label: '30Y' },
];

/** Inflation-view "Type:" selector — Core vs Headline. */
export const INFLATION_TYPE_OPTIONS: ReadonlyArray<{ value: InflationType; label: string }> =
  [
    { value: 'Core', label: 'Core' },
    { value: 'Headline', label: 'Headline' },
  ];

/** GDP-view "View:" selector — Nowcast vs Recession. */
export const GDP_VIEW_OPTIONS: ReadonlyArray<{ value: GdpViewSelector; label: string }> = [
  { value: 'Nowcast', label: 'Nowcast' },
  { value: 'Recession', label: 'Recession' },
];
